import React from 'react';
import {deleteReference} from './../entry/EntryActions';
import {getLexemeProperties} from '../../LexemePage';
import Dict from 'dict-lib';
import {Button, Grid, Row, Col} from 'react-bootstrap';
import './../../../../_css/lexeme.css';
import {SCSubmitButton} from "../../../../dict-components/submitButton/SCSubmitButton";


export class ReferenceDelete extends React.Component {

    constructor(props) {
        super(props);

        this._handleRemove = this._handleRemove.bind(this);
    }

    _handleRemove() {
        deleteReference(this.props.item.ids, this.props.additionalData.way === 'direct', this.props.additionalData.isPolyEdit);
    }

    render() {

        return <Grid fluid>
            <Row>
                <Col lg={7} md={7} className="popup-label">{Dict.t('ASK_DELETE_REFERENCE')}</Col>
                <Col lg={5} md={5}>
                    <SCSubmitButton onClick={this._handleRemove} text={Dict.t('YES')}/>
                </Col>
            </Row>
        </Grid>;
    }


}
